const DETAIL_DEFAULT_VALUES = {
  detail: {
    details: '<p></p>',
    choices: [
      { value: '1', label: '<p></p>', order: 1 },
      { value: '2', label: '<p></p>', order: 2 },
      { value: '3', label: '<p></p>', order: 3 },
      { value: '4', label: '<p></p>', order: 4 },
    ],
    correctAnswer: { value: undefined },
  },
};

const PROPERTIES_DEFAULT_VALUES = {
  properties: {
    learningObjectiveStatement: undefined,
    cognitiveDomain: [],
    solution: '<p></p>',
    reference: '<p></p>',
  },
};

const LOCATION_DEFAULT_VALUES = {
  location: {},
};

const INFORMATION_DEFAULT_VALUES = {
  information: {
    calculated: '',
    pValue: {
      pInitial: undefined,
      selected: undefined,
    },
  },
};

export const DEFAULT_FORM_VALUES = {
  ...LOCATION_DEFAULT_VALUES,
  ...INFORMATION_DEFAULT_VALUES,
  ...DETAIL_DEFAULT_VALUES,
  ...PROPERTIES_DEFAULT_VALUES,
};
